(function () {
  'use strict';

  angular
    .module('settings.customization.custom.field')
    .controller(
      'SettingsCustomizationCustomFieldCtrl',
      SettingsCustomizationCustomFieldCtrl,
    );

  SettingsCustomizationCustomFieldCtrl.$inject = [
    'CustomFieldCustomization',
    '$stateParams',
    '$rootScope',
    '$filter',
    '$translate',
  ];

  function SettingsCustomizationCustomFieldCtrl(
    CustomFieldCustomization,
    $stateParams,
    $rootScope,
    $filter,
    $translate,
  ) {
    var vm = this;
    vm.list = [];
    vm.title = '';
    vm.customField = {
      field_for: vm.customFieldFor,
      type: 1,
    };
    vm.fieldForList = {
      1: 'unit',
      2: 'lead',
      3: 'deal',
      4: 'deal_cancelation',
    };
    vm.customFieldOptions = ['', ''];
    vm.addOption = addOption;
    vm.addGroup = addGroup;
    vm.getCustomFieldTypeById = getCustomFieldTypeById;
    vm.getCustomFieldChoices = getCustomFieldChoices;

    vm.onCreate = onCreate;
    vm.onUpdate = onUpdate;
    vm.onDelete = onDelete;

    var textText = $translate.instant(
      'settings.page.customizations.custom.type.text',
    );
    var textNumber = $translate.instant(
      'settings.page.customizations.custom.type.number',
    );
    var textDate = $translate.instant(
      'settings.page.customizations.custom.type.date',
    );
    var textChoice = $translate.instant(
      'settings.page.customizations.custom.type.choice',
    );
    var textCantDelete = $translate.instant(
      'settings.page.customizations.custom.cant.delete',
    );
    $rootScope.$on('$translateChangeSuccess', function () {
      textText = $translate.instant(
        'settings.page.customizations.custom.type.text',
      );
      textNumber = $translate.instant(
        'settings.page.customizations.custom.type.number',
      );
      textDate = $translate.instant(
        'settings.page.customizations.custom.type.date',
      );
      textChoice = $translate.instant(
        'settings.page.customizations.custom.type.choice',
      );
      textCantDelete = $translate.instant(
        'settings.page.customizations.custom.cant.delete',
      );
    });

    vm.customFieldTypes = customFieldTypes();

    vm.init = init();

    function init() {
      getList();
    }

    function getList() {
      CustomFieldCustomization.getCustomFieldList(
        { field_for: vm.customFieldFor },
        function (response) {
          vm.list = response;
        },
      );
    }

    function customFieldTypes() {
      return [
        {
          id: 1,
          name: textText,
        },
        {
          id: 2,
          name: textNumber,
        },
        {
          id: 3,
          name: textDate,
        },
        {
          id: 4,
          name: textChoice,
        },
      ];
    }

    function getCustomFieldTypeById(id) {
      id = parseInt(id);
      var items = $filter('filter')(vm.customFieldTypes, { id: id }, true);

      return items.pop();
    }

    function getCustomFieldChoices(item) {
      if (item.type != 4) {
        return;
      }

      var choices = '';
      for (var i = 0; i < item.data.length; i++) {
        choices += item.data[i];
        if (i != item.data.length - 1) {
          choices += ' / ';
        }
      }

      return choices;
    }

    function onCreate() {
      var params = {
        field_for: vm.fieldForList[vm.customFieldFor],
      };

      if (vm.customField.type == 4) {
        vm.customField.data = vm.customFieldOptions;
        vm.customFieldOptions = ['', ''];
      }

      CustomFieldCustomization.createCustomField(
        params,
        vm.customField,
        function (response) {
          vm.list.push(response);
          vm.customField = {
            field_for: vm.customFieldFor,
            type: 1,
          };
        },
      );
    }

    function onUpdate(object) {
      var params = {
        id: object.id,
      };

      if (vm.customField.type == 4) {
        vm.customField.data = vm.customFieldOptions;
      }

      CustomFieldCustomization.updateCustomField(
        params,
        object,
        function (response) {
          getList();
        },
      );
    }

    function onDelete(object) {
      var params = {
        id: object.id,
      };

      if (vm.customField.type == 4) {
        vm.customField.data = vm.customFieldOptions;
      }

      CustomFieldCustomization.deleteCustomField(
        params,
        object,
        function (response) {
          if (response.hasOwnProperty('status')) {
            alert(textCantDelete);
          } else {
            vm.list.splice(vm.list.indexOf(object), 1);
          }
        },
      );
    }

    function addOption(index) {
      if (typeof index != 'undefined') {
        vm.customFieldOptions.splice(index + 1, 0, '');
      } else {
        vm.customFieldOptions.push('');
      }
    }

    function addGroup() {
      vm.customFieldOptions.push(
        '-- ' +
          $translate.instant(
            'settings.page.customizations.custom.table.group',
          ) +
          ' --',
      );
    }
  }
})();
